<template>
  <div class="oegen-page">
    <!-- 顶部操作栏 -->
    <div class="oegen-header">
      <div class="oegen-header-left">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="showAddDialog">创建任务</el-button>
      </div>
      <div class="oegen-header-right">
        <span class="oegen-count">共 <b>{{ taskList.length }}</b> 个任务</span>
        <el-button class="oegen-guide-btn" size="small" icon="el-icon-question" @click="goGuide">使用说明</el-button>
      </div>
    </div>

    <!-- 任务列表 -->
    <el-card shadow="never" class="oegen-card">
      <div slot="header" class="oegen-card-header">
        <i class="el-icon-s-grid"></i>
        <span>任务列表</span>
      </div>

      <div v-if="loading" class="oegen-loading">
        <i class="el-icon-loading"></i>
        <p>正在加载...</p>
      </div>

      <div v-else-if="taskList.length === 0" class="oegen-empty">
        <i class="el-icon-folder-opened"></i>
        <p>暂无任务，点击"创建任务"开始</p>
      </div>

      <el-table
        v-else
        :data="taskList"
        style="width: 100%"
        size="small"
        stripe
        :header-cell-style="{ background: '#fafbfc', color: '#606266', fontWeight: 600 }"
      >
        <el-table-column label="ID" prop="id" width="60" align="center"></el-table-column>
        <el-table-column label="任务名称" prop="tname" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="文件名" prop="dsrc" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="oegen-filename"><i class="el-icon-document"></i> {{ scope.row.dsrc || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_time" width="155" align="center"></el-table-column>
        <el-table-column label="操作" width="340" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="mini" icon="el-icon-view" @click="viewTask(scope.row)" plain>查看</el-button>
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="showEditDialog(scope.row)" plain>编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteTask(scope.row)" plain>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 创建/编辑任务对话框 -->
    <el-dialog
      :title="dialogType === 'add' ? '创建任务' : '编辑任务'"
      :visible.sync="taskDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <el-form :model="taskForm" label-width="100px" size="small">
        <el-form-item label="任务名称">
          <el-input v-model="taskForm.tname" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="上传文件">
          <div v-if="dialogType === 'edit' && taskForm.dsrc && !editFileChanged" class="oegen-current-file">
            <span><i class="el-icon-document"></i> {{ taskForm.dsrc }}</span>
            <el-button type="text" size="mini" @click="replaceFile" style="margin-left: 10px; color: #E6A23C;">更换文件</el-button>
          </div>
          <el-upload
            v-if="dialogType === 'add' || editFileChanged"
            ref="uploadRef"
            name="file"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :data="dialogType === 'add' ? { tname: taskForm.tname } : {}"
            :auto-upload="false"
            :limit="1"
            :on-exceed="handleExceed"
            :on-success="onUploadSuccess"
            :on-error="onUploadError"
            :before-upload="beforeUpload"
            accept=".xls,.xlsx"
          >
            <el-button size="small" type="primary" icon="el-icon-upload2">选择文件</el-button>
            <span slot="tip" class="el-upload__tip" style="margin-left: 10px;">只能上传 xls/xlsx 文件</span>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="taskDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" :loading="submitLoading" @click="submitTask">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OeGen",
  data() {
    return {
      taskList: [],
      loading: true,
      // 任务对话框
      taskDialogVisible: false,
      dialogType: "add", // add / edit
      taskForm: {
        id: 0,
        tname: "",
        dsrc: "",
      },
      editFileChanged: false,
      submitLoading: false,
      uploadHeaders: { Authorization: "Bearer " + localStorage.getItem("token") },
    };
  },
  computed: {
    uploadUrl() {
      return this.COMMON.httpUrl + "oegenTaskAdd";
    },
  },
  created() {
    this.loadTaskList();
  },
  methods: {
    // 查看任务详情
    viewTask(row) {
      this.$router.push({ name: "oegenDetail", params: { tid: String(row.id) } });
    },

    // 跳转到使用说明
    goGuide() {
      this.$router.push({ name: "oegenGuide" });
    },

    loadTaskList() {
      this.loading = true;
      var api = this.COMMON.httpUrl + "oegenTaskList";
      this.axios.post(api, {}).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.taskList = rs.data || [];
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$message.error("加载任务列表失败");
      });
    },

    // 创建任务
    showAddDialog() {
      this.dialogType = "add";
      this.taskForm = { id: 0, tname: "", dsrc: "" };
      this.editFileChanged = false;
      this.taskDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles();
        }
      });
    },

    // 编辑任务
    showEditDialog(row) {
      this.dialogType = "edit";
      this.taskForm = { id: row.id, tname: row.tname, dsrc: row.dsrc || "" };
      this.editFileChanged = false;
      this.taskDialogVisible = true;
    },

    // 更换文件
    replaceFile() {
      this.editFileChanged = true;
      this.$nextTick(() => {
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles();
        }
      });
    },

    // 提交任务
    submitTask() {
      if (!this.taskForm.tname.trim()) {
        this.$message.warning("任务名称不能为空");
        return;
      }
      if (this.dialogType === "add") {
        // 创建任务 - 通过upload组件上传
        if (!this.$refs.uploadRef || this.$refs.uploadRef.uploadFiles.length === 0) {
          this.$message.warning("请上传Excel文件");
          return;
        }
        this.submitLoading = true;
        // 手动设置上传附带的tname参数
        this.$refs.uploadRef.data = { tname: this.taskForm.tname };
        this.$refs.uploadRef.submit();
      } else {
        // 编辑任务
        this.submitLoading = true;
        var editApi = this.COMMON.httpUrl + "oegenTaskEdit";
        if (this.editFileChanged && this.$refs.uploadRef && this.$refs.uploadRef.uploadFiles.length > 0) {
          // 有新文件，用 FormData 上传
          var formData = new FormData();
          formData.append("id", this.taskForm.id);
          formData.append("tname", this.taskForm.tname);
          formData.append("file", this.$refs.uploadRef.uploadFiles[0].raw);
          this.axios.post(editApi, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          }).then((response) => {
            var rs = response.data;
            this.submitLoading = false;
            if (rs.code) {
              this.$message.error(rs.message);
            } else {
              this.$message.success("编辑成功");
              this.taskDialogVisible = false;
              this.loadTaskList();
            }
          }).catch(() => {
            this.submitLoading = false;
            this.$message.error("编辑失败");
          });
        } else {
          // 没有更换文件，只修改名称
          this.axios.post(editApi, { id: this.taskForm.id, tname: this.taskForm.tname }).then((response) => {
            var rs = response.data;
            this.submitLoading = false;
            if (rs.code) {
              this.$message.error(rs.message);
            } else {
              this.$message.success("编辑成功");
              this.taskDialogVisible = false;
              this.loadTaskList();
            }
          }).catch(() => {
            this.submitLoading = false;
            this.$message.error("编辑失败");
          });
        }
      }
    },

    // 上传前验证
    beforeUpload(file) {
      var ext = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (ext !== "xls" && ext !== "xlsx") {
        this.$message.warning("上传文件只能是 xls、xlsx 格式!");
        return false;
      }
    },

    handleExceed() {
      this.$message.warning("只能上传一个文件，请先移除已选文件");
    },

    onUploadSuccess(rs) {
      this.submitLoading = false;
      if (rs.code) {
        this.$message.error(rs.message);
      } else {
        this.$message.success("创建成功");
        this.taskDialogVisible = false;
        this.loadTaskList();
      }
    },

    onUploadError() {
      this.submitLoading = false;
      this.$message.error("上传失败");
    },

    // 删除任务
    deleteTask(row) {
      this.$confirm(`确认删除任务 "${row.tname}"？`, "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var api = this.COMMON.httpUrl + "oegenTaskDel";
        this.axios.post(api, { id: row.id }).then((response) => {
          var rs = response.data;
          if (rs.code) {
            this.$message.error(rs.message);
          } else {
            this.$message.success("删除成功");
            var index = this.taskList.findIndex(function (t) { return t.id === row.id; });
            if (index !== -1) {
              this.taskList.splice(index, 1);
            }
          }
        }).catch(() => {
          this.$message.error("删除失败");
        });
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.oegen-page {
  padding: 4px;
}

.oegen-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: linear-gradient(135deg, #ffffff 0%, #f7fafe 100%);
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid #ebeef5;
}

.oegen-header-left {
  display: flex;
  gap: 10px;
}

.oegen-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.oegen-guide-btn.el-button {
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  color: #5e6d82;
  font-weight: 500;
  transition: all 0.25s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.oegen-guide-btn.el-button:hover {
  color: #409EFF;
  border-color: #c6e2ff;
  background: linear-gradient(135deg, #ecf5ff 0%, #d9ecff 100%);
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.15);
  transform: translateY(-1px);
}

.oegen-guide-btn.el-button:active {
  transform: translateY(0);
}

.oegen-count {
  font-size: 13px;
  color: #606266;
}

.oegen-count b {
  color: #409EFF;
  font-size: 15px;
  font-weight: 700;
  margin: 0 2px;
}

.oegen-card {
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.oegen-card ::v-deep .el-card__header {
  padding: 12px 18px;
  background: #fafbfc;
  border-bottom: 1px solid #ebeef5;
}

.oegen-card ::v-deep .el-card__body {
  padding: 16px 18px;
}

.oegen-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.oegen-card-header i {
  color: #409EFF;
  font-size: 16px;
}

.oegen-loading {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.oegen-loading i {
  font-size: 36px;
  color: #409EFF;
}

.oegen-loading p {
  font-size: 14px;
  margin-top: 12px;
  color: #606266;
}

.oegen-empty {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.oegen-empty i {
  font-size: 56px;
  color: #c0c4cc;
}

.oegen-empty p {
  font-size: 14px;
  margin-top: 12px;
  color: #606266;
}

.oegen-filename {
  font-size: 12px;
  color: #606266;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.oegen-filename i {
  color: #67C23A;
}

.oegen-current-file {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  color: #606266;
}

.oegen-current-file i {
  color: #67C23A;
  margin-right: 4px;
}
</style>
